import React from 'react';

const LoadCoupons = (props) => {
    const renderCoupons = ({coupons}) => {
        if(coupons){
            return coupons.map((item) => {
                return (
                    <tr key={item._id}>
                        <td>{item.code}</td>
                        <td>{item.discount}%</td>
                    </tr>
                )
            })
        }
    }
    return (
        <>
            {renderCoupons(props)}
        </>
    )
}
export default LoadCoupons;